import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import SectionNavigation from './components/SectionNavigation';
import ContactHero from './components/ContactHero';
import EngagementOptions from './components/EngagementOptions';
import ContactForm from './components/ContactForm';
import LocationInfo from './components/LocationInfo';
import TrustIndicators from './components/TrustIndicators';

const ContactMultiChannelEngagementHub = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Contact - Multi-Channel Engagement Hub | Northstar Analytics</title>
        <meta 
          name="description" 
          content="Connect with Northstar Analytics through your preferred channel. Schedule consultations, request proposals, or speak directly with our data strategy experts. Dublin-based, GDPR compliant, 24-hour response guarantee." 
        />
        <meta name="keywords" content="contact data consultancy, Dublin analytics experts, GDPR compliant consultation, data strategy contact, Irish data consulting" />
        <meta property="og:title" content="Contact - Multi-Channel Engagement Hub | Northstar Analytics" />
        <meta property="og:description" content="Multiple ways to connect with our data strategy experts. From strategic consultations to technical assessments, we're here to guide your transformation." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/contact-multi-channel-engagement-hub" />
      </Helmet>
      <Header />
      <main className="pt-16 lg:pt-20">
        <div id="hero">
          <ContactHero />
        </div>
        <SectionNavigation />
        <div id="engagement-options">
          <EngagementOptions />
        </div>
        <div id="contact-form">
          <ContactForm />
        </div>
        <LocationInfo />
        <TrustIndicators />
      </main>
      <Footer />
    </div>
  );
};

export default ContactMultiChannelEngagementHub;